import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IUseTransferPendenciesTraysQueryParams } from '../../../types';

export const TRANSFER_PENDENCIES_TRAYS_QUERY_KEY =
  'transfer-pendencies-trays-query-key';

/**
 * This hook fetches the transfer pendencies trays list for a given filter type.
 */
export const useTransferPendenciesTraysQuery = (
  payload: IUseTransferPendenciesTraysQueryParams
) => {
  const { data, error, isError, isPending, refetch } = useQueryWithUserId({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      TRANSFER_PENDENCIES_TRAYS_QUERY_KEY,
      payload.inventoryTransferFilterType,
    ],
    networkMode: 'always',
    retry: false,
    enabled: false,
    queryFn: () => INV_MGMT_SERVICE_API.getTransferPendenciesTrays(payload),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
